
const isColorDark = (hex: string): boolean => {
  if (!hex) return false;

  const normalized = hex.replace('#', '');
  const r = parseInt(normalized.substring(0, 2), 16);
  const g = parseInt(normalized.substring(2, 4), 16);
  const b = parseInt(normalized.substring(4, 6), 16);

  // Perceived brightness formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness < 128;
};

export const getApexTheme = (theme: Record<string, string>) => {
  if (!theme) return {};
  const isDark = isColorDark(theme.background || '#ffffff');

  return {
    chart: {
      foreColor: theme.text || '#333',
      background: 'transparent',
      fontFamily: 'Inter, sans-serif',
      toolbar: { show: false },
    },
    legend: {
      labels: {
        colors: theme.text || '#333',
      },
    },
    xaxis: {
      labels: {
        style: {
          colors: theme.text || '#333',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: theme.text || '#333',
        },
      },
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
  };
};
